<div *ngIf="isFormContainsError" class="warranty-header-alert-msg" style="display: block;">
    <div class="content">
        <p>{{ 'common.form_global_error' | cxTranslate }}</p>
    </div>
</div>
<ng-container *ngIf="CanLoadPage$|async">
    <h1 class="fs-24 kbBlueText">{{'common.text_software_request_form_lable'|cxTranslate}}</h1>
    <p class="fs-20 h3-text" *ngIf="hideChoiceNote && !(softWareTypeCode == 'NEO')">
        {{'common.text_software_request_form_choice_lable'|cxTranslate}}</p>
    <div class="company-info py-2 px-3" [class.mb-3]="!(this.softWareTypeCode == 'TEBSG2')"
        *ngIf="isradioButtonrequired">
        <div [ngClass]="{'add-left-margin':topradio.length<3}" class="wrapper d-flex "
            [class.justify-content-around]="!(softWareTypeCode=='NEO')" [class.ml-5]="(softWareTypeCode=='NEO')">
            <ng-container *ngFor="let item of topradio">
                <ng-container *ngIf="langService.getActive()|async as lang ">
                    <div class="input-radio-inner-div  "
                        [ngClass]="(lang==='ru')|| (lang==='pl')?'font-diff-country':'fs-20'">
                        <input type="radio" class="radio-style" name="softwareChoice" [value]="item.key"
                            [checked]="topradioButtonState === item.key"
                            (change)="topradioButtonStateChanges(item.key)" />

                        <label>{{item.translationKey|cxTranslate}}</label>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <div class="fs-20 mt-4" *ngIf="showModel && !(this.softWareTypeCode == 'TRM')">
        <b class="bold-text" *ngIf="!(this.softWareTypeCode == 'EACS_EOL_Diagnostics')">{{pricestringValue}}</b>
    </div>
    <div class="important mb-3 fs-20" *ngIf="(this.softWareTypeCode == 'TEBSG2')">
        <div class="title">
            <div [innerHTML]="'common.text_software_request_form_tebs_info'|cxTranslate"></div>
        </div>
    </div>
    <div class="license-description mb-3 fs-20" *ngIf="(this.softWareTypeCode == 'NEO')">
        <div class="title">
            <div class="license-description important-note">
                <div [innerHTML]="'common.text_software_request_form_pin_important_note'|cxTranslate"></div>
            </div>
            <div [innerHTML]="'common.text_software_request_form_expiration_time1'|cxTranslate"></div>
            <div [innerHTML]="'common.text_software_request_form_expiration_time2'|cxTranslate"></div>
        </div>
    </div>
    <form [formGroup]="companyInfo">
        <section class="mb-4">
            <div class="mysoftTopHeader">{{'common.text_software_request_form_company_information_lable'|cxTranslate}}
            </div>
            <div class="company-info">
                <div *ngIf="isUserLoggedIn && (((this.topradioButtonState == 'softwareandpin') || (this.topradioButtonState == 'softwarerenewal'))) && !(softWareTypeCode == 'NEO')"
                    class="d-flex col-lg-12 col-md-12 col-sm-12 pt-4 justify-content-lg-center">
                    <button class="btn btn-primary btn-review" (click)="makeFormEditable()">
                        {{'common.text_software_request_edit'|cxTranslate}}
                    </button>
                </div>
                <div class="formWrapperDiv">
                    <div class="row col-12 px-0 mx-0">
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                            <label for="3dcad">{{'common.text_software_request_form_company_lable'|cxTranslate}}
                            </label>
                            <div>
                                <input formControlName="companyName" type="text">
                            </div>
                            <div
                                *ngIf="companyInfo.controls.companyName.invalid && companyInfo.controls.companyName.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.requestform_companyName_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                            <label for="3dcad">{{'common.text_software_request_form_roleinindustry_lable'|cxTranslate}}
                            </label>
                            <div class="form-group select-box">
                                <select formControlName="role" (change)="tradingPartnerEdit($event)">
                                    <option value="null" disabled [selected]="company.role.value == null">
                                        {{'common.form_select_empty'|cxTranslate}}</option>
                                    <option [value]="item.code" *ngFor="let item of apiResponse.industryRoleList">
                                        {{item.name}}
                                    </option>
                                </select>
                            </div>
                            <div *ngIf="companyInfo.controls.role.invalid && companyInfo.controls.role.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.requestform_roleInIndustry_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row col-12 px-0 mx-0">
                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label for="">{{'common.text_software_request_form_first_name_lable'|cxTranslate}}</label>
                            <input formControlName="firstName" type="text">
                            <div
                                *ngIf="companyInfo.controls.firstName.invalid && companyInfo.controls.firstName.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.profile_firstName_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label for="">{{'common.text_software_request_form_last_name_lable'|cxTranslate}}</label>
                            <input formControlName="lastName" type="text">
                            <div
                                *ngIf="companyInfo.controls.lastName.invalid && companyInfo.controls.lastName.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.address_lastName_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row col-12 px-0 mx-0">
                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label for="">{{'common.text_software_request_form_department_lable'|cxTranslate}}</label>
                            <input formControlName="department" type="text">
                            <div
                                *ngIf="companyInfo.controls.department.invalid && companyInfo.controls.department.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.address_lastName_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label for="">{{'common.text_core_submit_address_address'|cxTranslate}}</label>
                            <input formControlName="address" type="text">
                            <div *ngIf="companyInfo.controls.address.invalid && companyInfo.controls.address.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.requestform_address_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row col-12 px-0 mx-0">
                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label for="">{{'common.register_company_address_two'|cxTranslate}}</label>
                            <input formControlName="address2" type="text">
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label for="">{{'common.text_software_request_form_city_lable'|cxTranslate}}</label>
                            <input formControlName="city" type="text">
                            <div *ngIf="companyInfo.controls.city.invalid && companyInfo.controls.city.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.requestform_city_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row col-12 px-0 mx-0">
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                            <label for="3dcad">{{'common.text_software_request_form_postal_code_lable'|cxTranslate}}
                            </label>
                            <div>
                                <input formControlName="postalCode" type="text">
                                <div
                                    *ngIf="companyInfo.controls.postalCode.invalid && companyInfo.controls.postalCode.touched ">
                                    <span class="text_danger_show_acc">
                                        {{'common.requestform_postalCode_invalid'|cxTranslate}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                            <label for="3dcad">{{'common.text_software_request_form_country_lable'|cxTranslate}}
                            </label>
                            <div class="form-group select-box">
                                <select formControlName="country" (change)=" tradingPartnerEdit($event)">
                                    <option value="null" [selected]="company.country.value == null">
                                        {{'common.form_select_empty'|cxTranslate}}</option>
                                    <option [value]="item.isocode" *ngFor="let item of apiResponse.countriesList">
                                        {{item.name}}
                                    </option>
                                </select>
                            </div>
                            <div *ngIf="companyInfo.controls.country.invalid && companyInfo.controls.country.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.requestform_country_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row col-12 px-0 mx-0">
                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label for="">{{'common.text_software_request_form_phone_lable'|cxTranslate}}</label>
                            <div>
                                <input formControlName="phone" type="text">
                            </div>
                            <div *ngIf="companyInfo.controls.phone.invalid && companyInfo.controls.phone.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.requestform_phoneNumber_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label for="">{{'common.text_software_request_form_email_lable'|cxTranslate}}</label>
                            <div><input formControlName="email" type="email"></div>

                            <div *ngIf="companyInfo.controls.email.invalid && companyInfo.controls.email.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.requestform_emailID_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <!--  distributor manufacturer Engineering producation workshop trailer,truck Menufacturer -->
                    <div class="row col-12 px-0 mx-0" *ngIf="canShowTradingPartner">
                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label for="">{{'common.text_software_request_training_partner'|cxTranslate}}</label>
                            <ng-container *ngIf="isTradingPartnerIsInputBox;else showtradingPartnerDropDown">
                                <input formControlName="tradingPartner" type="text">
                            </ng-container>
                            <ng-template #showtradingPartnerDropDown>
                                <div class="form-group select-box">
                                    <select formControlName="tradingPartner">
                                        <option value="null" disabled [selected]="company.tradingPartner.value == null">
                                            {{'common.form_select_empty'|cxTranslate}}</option>

                                        <option [value]="item.name" *ngFor="let item of tradingPartnerDropdown">
                                            {{item.name}}
                                        </option>
                                    </select>
                                </div>
                            </ng-template>

                            <div
                                *ngIf="companyInfo.controls.tradingPartner.invalid && companyInfo.controls.tradingPartner.touched ">
                                <span class="text_danger_show_acc">
                                    {{'common.requestform_tradingPartner_invalid'|cxTranslate}}
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </form>

    <form [formGroup]="trainingInfo" *ngIf="showModel && !isNeo">
        <section>
            <div class="mysoftTopHeader">
                {{'common.text_software_request_form_information_about_training_lable'|cxTranslate}}</div>
            <div class="formWrapperDiv company-info">
                <div class="row col-12 px-0 mx-0">
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <label
                            for="">{{'common.text_software_request_form_ebs_person_firstname_lable'|cxTranslate}}</label>
                        <input formControlName="trainedpersonfirstname" type="text">
                        <div
                            *ngIf="trainingInfo.controls.trainedpersonfirstname.invalid && trainingInfo.controls.trainedpersonfirstname.touched ">
                            <span class="text_danger_show_acc">
                                {{'common.requestform_trainedPerson_firstName_invalid'|cxTranslate}}
                            </span>
                        </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <label
                            for="">{{'common.text_software_request_form_ebs_person_lastname_lable'|cxTranslate}}</label>
                        <input formControlName="trainedpersonlastname" type="text">
                        <div
                            *ngIf="trainingInfo.controls.trainedpersonlastname.invalid && trainingInfo.controls.trainedpersonlastname.touched ">
                            <span class="text_danger_show_acc">
                                {{'common.requestform_trainedPerson_lastName_invalid'|cxTranslate}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row col-12 px-0 mx-0">
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <label for="">{{'common.text_software_request_form_check_person_lable'|cxTranslate}}</label>
                        <div class="radiocontainerDiv mb-2">
                            <div class="trueradioDiv">
                                <input type="radio" [formControlName]="'trainedpersonstillAtCompany'"
                                    [value]="'true'"><span>{{'common.text_quote_yes_button_label'|cxTranslate}}</span>
                            </div>
                            <div class="falseradioDiv">
                                <input type="radio" [formControlName]="'trainedpersonstillAtCompany'"
                                    [value]="'false'"><span>{{'common.text_warranty_submit_labourrequested_no'|cxTranslate}}</span>
                            </div>
                        </div>
                        <div
                            *ngIf="trainingInfo.controls.trainedpersonstillAtCompany.value == 'false' && trainingInfo.controls.trainedpersonstillAtCompany.touched ">
                            <span class="text_danger_show_acc">
                                {{'common.requestform_trainedPersonStillAtCompany_invalid'|cxTranslate}}
                            </span>
                        </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6"
                        *ngIf="trainingInfo.controls.elearningCompleted.enabled">
                        <label
                            for="">{{'common.text_software_request_form_check_eLearning_course_lable'|cxTranslate}}</label>
                        <div class="radiocontainerDiv mb-2">
                            <div class="trueradioDiv">
                                <input type="radio" [formControlName]="'elearningCompleted'"
                                    [value]="'true'"><span>{{'common.text_software_request_form_check_yes_lable'|cxTranslate}}</span>
                            </div>
                            <div class="falseradioDiv">
                                <input type="radio" [formControlName]="'elearningCompleted'"
                                    [value]="'false'"><span>{{'common.text_software_request_form_check_no_lable'|cxTranslate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row col-12 px-0 mx-0">
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <label for="">{{'common.text_software_request_form_trainer_name_lable'|cxTranslate}}</label>
                        <input formControlName="trainerName" type="text">
                        <div
                            *ngIf="trainingInfo.controls.trainerName.invalid && trainingInfo.controls.trainerName.touched ">
                            <span class="text_danger_show_acc">
                                {{'common.requestform_trainnerName_invalid'|cxTranslate}}
                            </span>
                        </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <ng-container *ngIf="(softWareTypeCode == 'TEBS4' || softWareTypeCode == 'TEBSG2')">
                            <label
                                for="date">{{'common.text_software_request_form_dot_lable_elearning'|cxTranslate}}<ng-container
                                    [ngTemplateOutlet]="dateFormat"></ng-container></label>
                        </ng-container>
                        <ng-container *ngIf="!(softWareTypeCode == 'TEBS4' || softWareTypeCode == 'TEBSG2')">
                            <label for="date">{{'common.text_software_request_form_dot_lable'|cxTranslate}}<ng-container
                                    [ngTemplateOutlet]="dateFormat"></ng-container></label>
                        </ng-container>
                        <input formControlName="dateofTraining" style="border-radius: 0px !important;"
                            class="form-control disableDate kb-datePickerIcon" bsDatepicker [maxDate]="today"
                            [bsConfig]="{ dateInputFormat: bsConfigFormat,showWeekNumbers:false, displayOneMonthRange: true }"
                            placeholder={{localizedDateFormat.toLowerCase()}}>
                        <div
                            *ngIf="trainingInfo.controls.dateofTraining.invalid && trainingInfo.controls.dateofTraining.touched ">
                            <span class="text_danger_show_acc">
                                {{'common.requestform_trainingDate_invalid'|cxTranslate}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row col-12 px-0 mx-0">
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <label
                            for="">{{'common.text_software_request_form_place_of_training_lable'|cxTranslate}}</label>
                        <input formControlName="placeofTraining" type="text">
                        <div
                            *ngIf="trainingInfo.controls.placeofTraining.invalid && trainingInfo.controls.placeofTraining.touched ">
                            <span class="text_danger_show_acc">
                                {{'common.requestform_trainingPlace_invalid'|cxTranslate}}
                            </span>
                        </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <label
                            for="">{{'common.text_software_request_form_check_certificate_lable'|cxTranslate}}</label>
                        <div class="form-group file-upload js-file-upload col-lg-4 px-0 col-md-12">
                            <div class="file-upload__wrapper btn btn-blue btn-block" id="chooseFileButton">
                                <span
                                    class="fs-20 file-upload-text">{{'common.text_software_upload_file'|cxTranslate}}</span>
                                <input type="file" id="csvFile" name="csvFile" #fileInput
                                    class="file-upload__input js-file-upload__input" (input)="onFileSelected(fileInput)"
                                    accept=".pdf">
                            </div>
                        </div>
                        <div class="mt-2" *ngIf="fileName">{{fileName}}</div>
                    </div>
                </div>
            </div>
        </section>
    </form>
    <form [formGroup]="quantityOfLicense" *ngIf="isNeo">
        <section>
            <div class="mysoftTopHeader">
                {{'common.text_software_quantity_license'|cxTranslate}}</div>
            <div class="formWrapperDiv bgColor">
                <div class="row col-12 px-0 mx-0">
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <label for="">{{'common.text_software_quantity_license_lable'|cxTranslate}}</label>
                        <input formControlName="quantity" type="number" ngModel [maxlength]="1"
                            [placeholder]="'common.placeholder_quantity_lable_validation'|cxTranslate">
                        <div
                            *ngIf="quantityOfLicense.controls.quantity.invalid && quantityOfLicense.controls.quantity.touched ">
                            <span class="text_danger_show_acc">
                                {{'common.text_warranty_submit_quantity_invalid'|cxTranslate}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </form>
    <ng-container *ngIf="isreview">
        <form [formGroup]="captchaSection">
            <section class="recapctha-Section mt-4">
                <div class="mb-2">
                    <input type="checkbox" formControlName="licenseCheckBox">
                    <div class="kbBlueText ">{{'common.text_software_search_type_code_i_have_read'|cxTranslate}}
                        <u><a class="kbBlueText" [href]="apiResponse?.softwarePackageInfo?.licenseAgreementsDocUrl"
                                target="_blank" (click)="captchaSection.controls.licenseCheckBox.setValue(true) ">
                                {{'common.text_software_request_form_licence_agreement_lable'|cxTranslate}}</a></u>
                    </div>
                </div>
                <div class="mb-2">
                    <input type="checkbox" formControlName="privacyTermsCheckBox">
                    <div class="kbBlueText">{{'common.text_software_search_type_code_i_have_read'|cxTranslate}}
                        <u (click)="openPrivacyPopup()">
                            {{'common.text_software_request_form_privacy_agreement_lable'|cxTranslate}}
                        </u>
                    </div>
                </div>
                <div class="mb-2">
                    <input type="checkbox" formControlName="webShopCheckBox">
                    <div class="kbBlueText">{{'common.text_software_search_type_code_i_accept_the'|cxTranslate}}
                        <u (click)="openWebshop()">
                            {{'common.text_software_request_form_conditions_lable'|cxTranslate}}
                        </u>
                    </div>
                </div>
                <div class="form-group col-xs-12 col-sm-12 software-captcha">
                    <div class="col-xs-12 col-sm-12 col-md-12 pl-0" *ngIf="!kbCaptchaForChina">
                        <re-captcha id="recaptcha" formControlName="recaptcha" (resolved)="checkCaptcha($event)"
                            formControlName="recaptcha" name="recaptcha" required></re-captcha>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-3 pl-0" *ngIf="kbCaptchaForChina">
                        <img [src]="imageUrl" alt="Captcha Image" (click)="refreshCaptcha()">
                        <input class="kb-captcha mt-2" type="text" [(ngModel)]="captchaInput"
                            formControlName="recaptcha" placeholder="Enter Captcha" maxlength="6"
                            (input)="inputValue($event);">

                        <div class="captchaError" *ngIf="captchaEmpty">
                            {{'common.register_captcha_invalid_msg'|cxTranslate}}
                        </div>
                        <div class="captchaError" *ngIf="captchaExpired">
                            {{'common.register_captcha_expired_msg'|cxTranslate}}
                        </div>
                        <div class="captchaError" *ngIf="captchaInvalid">
                            {{'common.register_captcha_invalid_msg'|cxTranslate}}
                        </div>
                    </div>
                    <div class="invalid-feedback"
                        *ngIf="captchaSection.controls.recaptcha.invalid && (captchaSection.controls.recaptcha.dirty || captchaSection.controls.recaptcha.touched)">
                        {{'common.register_captcha_invalid_msg'|cxTranslate}}</div>
                </div>
            </section>
        </form>
    </ng-container>
    <section class="mt-4">
        <div class="row mx-0">
            <ng-container *ngIf="langService.getActive()|async as lang ">
                <button class="btn btn-primary mr-1 mb-sm-3 mb-3 mb-md-0 btn-review"
                    [ngClass]="lang.toUpperCase()=='EN_GB' ? 'col-lg-2 col-md-3 col-sm-12' : 'col-lg-4 col-md-6 col-sm-12'"
                    (click)="canSubmit()">
                    {{'common.text_software_request_form_review_lable'|cxTranslate}}</button>
                <button *ngIf="showModel || isNeo;else submit"
                    class="btn btn-primary btn-submit col-lg-4 col-md-6 col-sm-12"
                    [ngClass]="lang.toUpperCase()=='EN_GB' ? 'col-lg-4 col-md-6 col-sm-12' : ''" (click)="onSubmit()"
                    [disabled]="isSubmitDisabled || (!isRecaptchaDone || !this.captchaSectionFormControls.licenseCheckBox.value
                                    || !this.captchaSectionFormControls.privacyTermsCheckBox.value
                                   || !this.captchaSectionFormControls.webShopCheckBox.value)">
                    {{'common.text_software_request_form_withpin_lable'|cxTranslate}}
                    <img class="hover-img" src="icons/link-grey.svg" width="20px">
                </button>
                <ng-template #submit>
                    <button class="btn btn-primary btn-submit col-lg-2 col-md-3 col-sm-12"
                        [ngClass]="lang.toUpperCase()=='EN_GB' ? 'col-lg-2 col-md-3 col-sm-12' : 'col-lg-4 col-md-6 col-sm-12'"
                        (click)="onSubmit()" [disabled]="isSubmitDisabled ||(!isRecaptchaDone || !this.captchaSectionFormControls.licenseCheckBox.value
                                                         || !this.captchaSectionFormControls.privacyTermsCheckBox.value
                                                        || !this.captchaSectionFormControls.webShopCheckBox.value
                        )">
                        {{'common.text_software_request_form_submit_button_lable'|cxTranslate}}
                        <img class="hover-img" src="icons/link-grey.svg" width="20px">
                    </button>
                </ng-template>
            </ng-container>
        </div>
    </section>
</ng-container>

<ng-template #dateFormat>
    <ng-container *ngIf="countryService.getActive()|async as currentCountry ">
        <ng-container *ngIf="langService.getActive()|async as lang ">
            <ng-container *ngIf="currentCountry.toUpperCase() == 'FR' && lang =='fr';else dateFromBE">
                {{'common.date_format_capital'|cxTranslate}}
            </ng-container>
            <ng-template #dateFromBE>
                ({{apiResponse?.dateFormat}})*
            </ng-template>
        </ng-container>
    </ng-container>
</ng-template>